/*
 * @Author: wang hui
 * @Date: 2021-04-30 13:08:08
 * @LastEditTime: 2021-05-06 12:11:34
 * @LastEditors: Please set LastEditors
 * @Description: 入口文件
 * @FilePath: \Wjb-Website\src\main.js
 */
import Vue from 'vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'amfe-flexible'
// 样式管理
import './assets/css/global.css';
// import 'bootstrap/dist/css/bootstrap.css'
// import 'bootstrap-vue/dist/bootstrap-vue.css'

// 加载BootstrapVue
Vue.use(BootstrapVue)
// 可选加载BootstrapVue图标组件插件
Vue.use(IconsPlugin)

Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')